var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapbox"},[_c('div',{staticClass:"closebtn",on:{"click":function($event){return _vm.$emit('goBack')}}},[_vm._v("关闭 ×")]),_c('div',{staticClass:"imgbox"},_vm._l((_vm.images),function(img,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":img}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }